__turbopack_context__.v({
  "button": "BONQ2W_button",
  "button_dark": "BONQ2W_button_dark",
});
